import { GET_PRODUCTS_LIST, GET_VENDORS } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export type vendorAccount = {
  associatedDomainName: string;
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const vendorAccountInitialValues: vendorAccount = {
  associatedDomainName: "",
  created_at: [null, null],
  updated_at: [null, null],
};

export const vendorAccountMandatoryFields = [];

export const vendorAccountValidationSchema = Yup.object().shape({
  created_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  updated_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
});

export const vendorAccountProperties = [
  {
    id: "associatedDomainName",
    type: "text",
    label: "Associated Domain Name",
    Placeholder: "Enter Associated Domain Name",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "vendorId",
    type: "single-select-search",
    label: "Vendor",
    // list: "vendors_gq",
    keyValue: { label: "name", value: "id" },
    query: GET_VENDORS,
    gqlKey: "getVendors",
    dataKey: "vendors",
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "productId",
    type: "single-select-search",
    label: "Product",
    // list: "products_gq",
    keyValue: { label: "name", value: "id" },
    query: GET_PRODUCTS_LIST,
    gqlKey: "getProducts",
    dataKey: "products",
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    className: "updated-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj: any, keys: any[]) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every((v) => v === null))
    );
  });
}
